export default __webpack_public_path__ + "static/media/People_Partners.aed1c073.svg";